export class saleOrder {
  saleOrderId: number;
  plantId?: number;
  /**
  * @param saleOrderId
  * */


  constructor(saleOrderId: number, plantId?: number) {
    this.saleOrderId = saleOrderId;
    this.plantId = plantId;
  }
}

export class SaleOrderNumberRequest {
  saleOrderNumber: string;
  plantId?: number;

  /**
   * 
   * @param saleOrderNumber 
   * @param plantId 
   */
  constructor(saleOrderNumber: string, plantId?: number) {
    this.saleOrderNumber = saleOrderNumber;
    this.plantId = plantId;
  }
}
export class ItemRequest {
  saleOrderId: number;
  categoryId?: number;

  /**
   * 
   * @param saleOrderId 
   * @param categoryId 
   */
  constructor(saleOrderId: number, categoryId: number) {
    this.saleOrderId = saleOrderId;
    this.categoryId = categoryId;
  }
}

export class SaleOrderTrackFilters {
  selectedEstimatedFromDate: string;
  selectedEstimatedToDate: string;
  saleOrderStatus: string;
  selectedEndCustomer: number;
  unit: any;
  prodUnit?: any;
  destinations?: number[];
  countryId?: number;
  selectedCreatedFromDate?: string;
  selectedCreatedToDate?: string;
  masterBrandId?: number;
  varientCode?: number;
  readyForShipment?: boolean;
}
export class SaleOrderItemsCasesRequest {
  saleOrderId: number;
  saleOrderItemId: number;
  reportingCases: number;
  reportedDate: Date;
}
export class SaleOrderItemsRequest {
  saleOrderId: number;
  saleOrderItemId: number;
  plantId?: number;
  stockType?: string;
}
